import {TranslationKey} from './TranslationKeyTypes'

export const allFeatureFlags = [
  'admin_tools',
  'collections',
  'official_collections',
  'show_features',
  'developer_settings'
] as const
export type FeatureFlag = (typeof allFeatureFlags)[number]
export type FeatureFlagSubset = Partial<Record<FeatureFlag, boolean>>
export const featureFlagDisplayName: Record<FeatureFlag, TranslationKey> = {
  admin_tools: 'adminTools',
  collections: 'featureCollections',
  official_collections: 'featureOfficialCollections',
  show_features: 'featureShowFeatures',
  developer_settings: 'developer'
}
